var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("pui-lightbox", {
    ref: "unitModal",
    attrs: { "on-close-callback": _vm.cancel },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function () {
          return [
            _c("div", [
              _c(
                "div",
                { attrs: { id: "unit-modal", tabindex: "-1", role: "dialog" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-dialog modal-dialog-centered",
                      staticStyle: { "max-width": "1400px" },
                      attrs: { role: "document" },
                    },
                    [
                      _c("div", { staticClass: "modal-content" }, [
                        _c("div", { staticClass: "modal-header" }, [
                          _c(
                            "h5",
                            {
                              staticClass: "modal-title",
                              attrs: { id: "plant-modal-label" },
                            },
                            [
                              _vm.unit.id === undefined
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("addNewUnit"))),
                                  ])
                                : _vm._e(),
                              _vm.unit.id > 0
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$t("editUnit"))),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _c(
                          "div",
                          { staticClass: "modal-body pt-3" },
                          [
                            _vm.loading === true
                              ? _c("loading-spinner")
                              : _vm._e(),
                            _vm.loading === false
                              ? _c("div", { staticClass: "tab-container" }, [
                                  _c("ul", { staticClass: "tabs" }, [
                                    _c(
                                      "li",
                                      {
                                        class: {
                                          "tab-active":
                                            _vm.tabs.item.active === true,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleTab(_vm.tabs.item)
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("unit")) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      {
                                        class: {
                                          "tab-active":
                                            _vm.tabs.planning.active === true,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleTab(
                                              _vm.tabs.planning
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("planning")) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "li",
                                      {
                                        class: {
                                          "tab-active":
                                            _vm.tabs.unitOH.active === true,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleTab(
                                              _vm.tabs.unitOH
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" " + _vm._s(_vm.$t("oh")) + " ")]
                                    ),
                                    _c(
                                      "li",
                                      {
                                        class: {
                                          "tab-active":
                                            _vm.tabs.geneva.active === true,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleTab(
                                              _vm.tabs.geneva
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.$t("geneva")) + " "
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.tabs.item.active === true,
                                          expression:
                                            "tabs.item.active === true",
                                        },
                                      ],
                                    },
                                    [
                                      _vm.structureLoading
                                        ? _c("loading-spinner")
                                        : [
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group flex-nowrap input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("unitName")
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model.trim",
                                                        value: _vm.unit.name,
                                                        expression: "unit.name",
                                                        modifiers: {
                                                          trim: true,
                                                        },
                                                      },
                                                    ],
                                                    class: [
                                                      {
                                                        "is-invalid":
                                                          _vm.getValidateObject(
                                                            "name"
                                                          ),
                                                      },
                                                      "form-control",
                                                    ],
                                                    attrs: {
                                                      type: "text",
                                                      placeholder:
                                                        _vm.$t("unitName"),
                                                      disabled: _vm.unit.name,
                                                    },
                                                    domProps: {
                                                      value: _vm.unit.name,
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.unit,
                                                          "name",
                                                          $event.target.value.trim()
                                                        )
                                                      },
                                                      blur: function ($event) {
                                                        return _vm.$forceUpdate()
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: {
                                                        "invalid-feedback":
                                                          _vm.getValidateObject(
                                                            "name"
                                                          ),
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.getValidateObject(
                                                        "name"
                                                      ),
                                                      function (error) {
                                                        return _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(error) +
                                                              " "
                                                          ),
                                                        ])
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "commissioningDate"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("date-picker", {
                                                    attrs: {
                                                      type: "date",
                                                      format: "YYYY-MM-DD",
                                                      "value-type": "format",
                                                      "append-to-body": false,
                                                      "popup-style": {
                                                        position: "fixed",
                                                        top: "unset",
                                                        left: "unset",
                                                      },
                                                      "input-class": [
                                                        {
                                                          "is-invalid":
                                                            _vm.getValidateObject(
                                                              "commissioningDate"
                                                            ) ||
                                                            _vm.isInputInvalid(
                                                              _vm.unit
                                                                .commissioningDate,
                                                              _vm.commissioningDateItemChanged,
                                                              2
                                                            ) ||
                                                            !_vm.areDatesValid(
                                                              _vm.unit
                                                                .commissioningDate,
                                                              _vm.commissioningDateItemChanged,
                                                              _vm.unit
                                                                .plannedEndDate,
                                                              _vm.plannedEndDateItemChanged
                                                            ),
                                                        },
                                                        "form-control form-control-sm",
                                                      ],
                                                      "input-attr": {
                                                        required: "true",
                                                      },
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.handleCommissioningDateItemChanged,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.unit
                                                          .commissioningDate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.unit,
                                                          "commissioningDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "unit.commissioningDate",
                                                    },
                                                  }),
                                                  !_vm.areDatesValid(
                                                    _vm.unit.commissioningDate,
                                                    _vm.commissioningDateItemChanged,
                                                    _vm.unit.plannedEndDate,
                                                    _vm.plannedEndDateItemChanged
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback d-block",
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "errorCommissioningDate"
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm.getValidateObject(
                                                    "commissioningDate"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback d-block",
                                                        },
                                                        _vm._l(
                                                          _vm.getValidateObject(
                                                            "commissioningDate"
                                                          ),
                                                          function (error) {
                                                            return _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    error
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ])
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]),
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group flex-nowrap input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("fuelType")
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.unit.fuelType,
                                                          expression:
                                                            "unit.fuelType",
                                                        },
                                                      ],
                                                      class: [
                                                        {
                                                          "is-invalid":
                                                            _vm.getValidateObject(
                                                              "fuelType"
                                                            ),
                                                        },
                                                        "form-control",
                                                      ],
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            _vm.unit,
                                                            "fuelType",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.fuelTypes,
                                                      function (type) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: type.value,
                                                            domProps: {
                                                              value: type.value,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    type.label
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: {
                                                        "invalid-feedback":
                                                          _vm.getValidateObject(
                                                            "fuelType"
                                                          ),
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.getValidateObject(
                                                        "fuelType"
                                                      ),
                                                      function (error) {
                                                        return _c("span", [
                                                          _vm._v(_vm._s(error)),
                                                        ])
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group flex-nowrap input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "grossCapacity"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName:
                                                          "v-model.lazy.number",
                                                        value:
                                                          _vm.unit
                                                            .grossCapacity,
                                                        expression:
                                                          "unit.grossCapacity",
                                                        modifiers: {
                                                          lazy: true,
                                                          number: true,
                                                        },
                                                      },
                                                    ],
                                                    class: [
                                                      {
                                                        "is-invalid":
                                                          _vm.getValidateObject(
                                                            "grossCapacity"
                                                          ) ||
                                                          _vm.isInputInvalid(
                                                            _vm.unit
                                                              .grossCapacity,
                                                            true,
                                                            3
                                                          ),
                                                      },
                                                      "form-control",
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                      placeholder:
                                                        _vm.$t("grossCapacity"),
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.unit.grossCapacity,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.$set(
                                                          _vm.unit,
                                                          "grossCapacity",
                                                          _vm._n(
                                                            $event.target.value
                                                          )
                                                        )
                                                      },
                                                      blur: function ($event) {
                                                        return _vm.$forceUpdate()
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: {
                                                        "invalid-feedback":
                                                          _vm.getValidateObject(
                                                            "grossCapacity"
                                                          ),
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.getValidateObject(
                                                        "grossCapacity"
                                                      ),
                                                      function (error) {
                                                        return _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(error) +
                                                              " "
                                                          ),
                                                        ])
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group flex-nowrap input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "minCapacity"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName:
                                                          "v-model.lazy.number",
                                                        value:
                                                          _vm.unit.minCapacity,
                                                        expression:
                                                          "unit.minCapacity",
                                                        modifiers: {
                                                          lazy: true,
                                                          number: true,
                                                        },
                                                      },
                                                    ],
                                                    class: [
                                                      {
                                                        "is-invalid":
                                                          _vm.getValidateObject(
                                                            "minCapacity"
                                                          ) ||
                                                          _vm.isInputInvalid(
                                                            _vm.unit
                                                              .minCapacity,
                                                            true,
                                                            3
                                                          ),
                                                      },
                                                      "form-control",
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                      placeholder:
                                                        _vm.$t("minCapacity"),
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.unit.minCapacity,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.$set(
                                                          _vm.unit,
                                                          "minCapacity",
                                                          _vm._n(
                                                            $event.target.value
                                                          )
                                                        )
                                                      },
                                                      blur: function ($event) {
                                                        return _vm.$forceUpdate()
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: {
                                                        "invalid-feedback":
                                                          _vm.getValidateObject(
                                                            "minCapacity"
                                                          ),
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.getValidateObject(
                                                        "minCapacity"
                                                      ),
                                                      function (error) {
                                                        return _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(error) +
                                                              " "
                                                          ),
                                                        ])
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group flex-nowrap input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "maxCapacity"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName:
                                                          "v-model.lazy.number",
                                                        value:
                                                          _vm.unit.maxCapacity,
                                                        expression:
                                                          "unit.maxCapacity",
                                                        modifiers: {
                                                          lazy: true,
                                                          number: true,
                                                        },
                                                      },
                                                    ],
                                                    class: [
                                                      {
                                                        "is-invalid":
                                                          _vm.getValidateObject(
                                                            "maxCapacity"
                                                          ) ||
                                                          _vm.isInputInvalid(
                                                            _vm.unit
                                                              .maxCapacity,
                                                            true,
                                                            3
                                                          ),
                                                      },
                                                      "form-control",
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                      placeholder:
                                                        _vm.$t("maxCapacity"),
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.unit.maxCapacity,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.$set(
                                                          _vm.unit,
                                                          "maxCapacity",
                                                          _vm._n(
                                                            $event.target.value
                                                          )
                                                        )
                                                      },
                                                      blur: function ($event) {
                                                        return _vm.$forceUpdate()
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: {
                                                        "invalid-feedback":
                                                          _vm.getValidateObject(
                                                            "maxCapacity"
                                                          ),
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.getValidateObject(
                                                        "maxCapacity"
                                                      ),
                                                      function (error) {
                                                        return _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(error) +
                                                              " "
                                                          ),
                                                        ])
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group flex-nowrap input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "outageCycle"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName:
                                                          "v-model.lazy.number",
                                                        value:
                                                          _vm.unit.outageCycle,
                                                        expression:
                                                          "unit.outageCycle",
                                                        modifiers: {
                                                          lazy: true,
                                                          number: true,
                                                        },
                                                      },
                                                    ],
                                                    class: [
                                                      {
                                                        "is-invalid":
                                                          _vm.getValidateObject(
                                                            "outageCycle"
                                                          ) ||
                                                          _vm.isInputInvalid(
                                                            _vm.unit
                                                              .outageCycle,
                                                            true,
                                                            3
                                                          ),
                                                      },
                                                      "form-control",
                                                    ],
                                                    attrs: {
                                                      type: "number",
                                                      placeholder:
                                                        _vm.$t("outageCycle"),
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.unit.outageCycle,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        _vm.$set(
                                                          _vm.unit,
                                                          "outageCycle",
                                                          _vm._n(
                                                            $event.target.value
                                                          )
                                                        )
                                                      },
                                                      blur: function ($event) {
                                                        return _vm.$forceUpdate()
                                                      },
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: {
                                                        "invalid-feedback":
                                                          _vm.getValidateObject(
                                                            "outageCycle"
                                                          ),
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.getValidateObject(
                                                        "outageCycle"
                                                      ),
                                                      function (error) {
                                                        return _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(error) +
                                                              " "
                                                          ),
                                                        ])
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group flex-nowrap input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "plannedEndDate"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("date-picker", {
                                                    attrs: {
                                                      type: "date",
                                                      format: "YYYY-MM-DD",
                                                      "value-type": "format",
                                                      "append-to-body": false,
                                                      "popup-style": {
                                                        position: "fixed",
                                                        top: "unset",
                                                        left: "unset",
                                                      },
                                                      "input-class": [
                                                        {
                                                          "is-invalid":
                                                            _vm.getValidateObject(
                                                              "plannedEndDate"
                                                            ) ||
                                                            _vm.isInputInvalid(
                                                              _vm.unit
                                                                .plannedEndDate,
                                                              _vm.plannedEndDateItemChanged,
                                                              2
                                                            ),
                                                        },
                                                        "form-control form-control-sm",
                                                      ],
                                                    },
                                                    on: {
                                                      change:
                                                        _vm.handlePlannedEndDateItemChanged,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.unit.plannedEndDate,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.unit,
                                                          "plannedEndDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "unit.plannedEndDate",
                                                    },
                                                  }),
                                                  _vm.getValidateObject(
                                                    "plannedEndDate"
                                                  )
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "invalid-feedback d-block",
                                                        },
                                                        _vm._l(
                                                          _vm.getValidateObject(
                                                            "plannedEndDate"
                                                          ),
                                                          function (error) {
                                                            return _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    error
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ])
                                                          }
                                                        ),
                                                        0
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]),
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group flex-nowrap input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "summerOperatingRegime"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.unit
                                                              .summerOperatingRegime,
                                                          expression:
                                                            "unit.summerOperatingRegime",
                                                        },
                                                      ],
                                                      class: [
                                                        {
                                                          "is-invalid":
                                                            _vm.getValidateObject(
                                                              "summerOperatingRegime"
                                                            ),
                                                        },
                                                        "form-control",
                                                      ],
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            _vm.unit,
                                                            "summerOperatingRegime",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.operatingRegimeTypes,
                                                      function (regime) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: regime.value,
                                                            domProps: {
                                                              value:
                                                                regime.value,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    regime.label
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: {
                                                        "invalid-feedback":
                                                          _vm.getValidateObject(
                                                            "summerOperatingRegime"
                                                          ),
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.getValidateObject(
                                                        "summerOperatingRegime"
                                                      ),
                                                      function (error) {
                                                        return _c("span", [
                                                          _vm._v(_vm._s(error)),
                                                        ])
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group flex-nowrap input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "winterOperatingRegime"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.unit
                                                              .winterOperatingRegime,
                                                          expression:
                                                            "unit.winterOperatingRegime",
                                                        },
                                                      ],
                                                      class: [
                                                        {
                                                          "is-invalid":
                                                            _vm.getValidateObject(
                                                              "winterOperatingRegime"
                                                            ),
                                                        },
                                                        "form-control",
                                                      ],
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            _vm.unit,
                                                            "winterOperatingRegime",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.operatingRegimeTypes,
                                                      function (regime) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: regime.value,
                                                            domProps: {
                                                              value:
                                                                regime.value,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    regime.label
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: {
                                                        "invalid-feedback":
                                                          _vm.getValidateObject(
                                                            "winterOperatingRegime"
                                                          ),
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.getValidateObject(
                                                        "winterOperatingRegime"
                                                      ),
                                                      function (error) {
                                                        return _c("span", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(error) +
                                                              " "
                                                          ),
                                                        ])
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group flex-nowrap input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "technology"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.unit.technology,
                                                          expression:
                                                            "unit.technology",
                                                        },
                                                      ],
                                                      class: [
                                                        {
                                                          "is-invalid":
                                                            _vm.getValidateObject(
                                                              "technology"
                                                            ),
                                                        },
                                                        "form-control",
                                                      ],
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            _vm.unit,
                                                            "technology",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.technologyTypes,
                                                      function (technology) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: technology.value,
                                                            domProps: {
                                                              value:
                                                                technology.value,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    technology.label
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      class: {
                                                        "invalid-feedback":
                                                          _vm.getValidateObject(
                                                            "technology"
                                                          ),
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.getValidateObject(
                                                        "technology"
                                                      ),
                                                      function (error) {
                                                        return _c("span", [
                                                          _vm._v(_vm._s(error)),
                                                        ])
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group flex-nowrap input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "machineSID"
                                                              )
                                                            ) +
                                                              " (Sara, " +
                                                              _vm._s(
                                                                _vm.$t("geneva")
                                                              ) +
                                                              ")"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.unit.machineSID,
                                                        expression:
                                                          "unit.machineSID",
                                                      },
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      placeholder:
                                                        _vm.$t("machineSID") +
                                                        "(Sara, Geneva)",
                                                      disabled: _vm.unit.name,
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.unit.machineSID,
                                                    },
                                                    on: {
                                                      change: function (
                                                        $event
                                                      ) {
                                                        return _vm.machineSIDChange()
                                                      },
                                                      input: function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.unit,
                                                          "machineSID",
                                                          $event.target.value
                                                        )
                                                      },
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]),
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                { staticClass: "col-6" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group flex-nowrap input-group-sm",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group-prepend",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group-text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "genevaEOHUsageFactor"
                                                                    )
                                                                  ) +
                                                                  " (K): "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c("input", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName:
                                                              "v-model.number",
                                                            value:
                                                              _vm.unit
                                                                .genevaEOHFactor,
                                                            expression:
                                                              "unit.genevaEOHFactor",
                                                            modifiers: {
                                                              number: true,
                                                            },
                                                          },
                                                        ],
                                                        class: [
                                                          {
                                                            "is-invalid is-invalid-warning":
                                                              _vm.getValidateObject(
                                                                "genevaEOHFactor"
                                                              ) ||
                                                              _vm.isInputInvalid(
                                                                _vm.unit
                                                                  .genevaEOHFactor,
                                                                true,
                                                                1
                                                              ),
                                                          },
                                                          "form-control",
                                                        ],
                                                        attrs: {
                                                          type: "number",
                                                          placeholder: _vm.$t(
                                                            "genevaEOHUsageFactor"
                                                          ),
                                                          min: "0",
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm.unit
                                                              .genevaEOHFactor,
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.handlegenevaEOHFactorItemChanged,
                                                          input: function (
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              _vm.unit,
                                                              "genevaEOHFactor",
                                                              _vm._n(
                                                                $event.target
                                                                  .value
                                                              )
                                                            )
                                                          },
                                                          blur: function (
                                                            $event
                                                          ) {
                                                            return _vm.$forceUpdate()
                                                          },
                                                        },
                                                      }),
                                                      _c(
                                                        "div",
                                                        {
                                                          class: {
                                                            "invalid-feedback":
                                                              _vm.getValidateObject(
                                                                "genevaEOHFactor"
                                                              ),
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.getValidateObject(
                                                            "genevaEOHFactor"
                                                          ),
                                                          function (error) {
                                                            return _c("span", [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    error
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ])
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "mt-3 mb-3 formula",
                                                    },
                                                    [
                                                      _c("i", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t("formula")
                                                          ) +
                                                            ": EOH=OHgeneva + "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticStyle: {
                                                              color: "red",
                                                            },
                                                          },
                                                          [_vm._v("K")]
                                                        ),
                                                        _vm._v(
                                                          " * totalStartsGeneva"
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group flex-nowrap input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "PMHMapping"
                                                              )
                                                            ) + ":"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value:
                                                            _vm.unit
                                                              .enerlyticsId,
                                                          expression:
                                                            "unit.enerlyticsId",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.$set(
                                                            _vm.unit,
                                                            "enerlyticsId",
                                                            $event.target
                                                              .multiple
                                                              ? $$selectedVal
                                                              : $$selectedVal[0]
                                                          )
                                                        },
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.enerlyticsUnits,
                                                      function (unit) {
                                                        return _c(
                                                          "option",
                                                          {
                                                            key: unit.unit_id,
                                                            staticClass:
                                                              "plant-info",
                                                            domProps: {
                                                              value:
                                                                unit.unit_id,
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  unit.unit_id
                                                                    ? _vm.$t(
                                                                        "unit"
                                                                      ) +
                                                                        ": " +
                                                                        unit.unit_name
                                                                    : unit.unit_name
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    0
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group input-group-sm",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("subUnit")
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-append",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.unit
                                                                    .isSubUnit,
                                                                expression:
                                                                  "unit.isSubUnit",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "checkbox",
                                                            },
                                                            domProps: {
                                                              checked:
                                                                Array.isArray(
                                                                  _vm.unit
                                                                    .isSubUnit
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.unit
                                                                        .isSubUnit,
                                                                      null
                                                                    ) > -1
                                                                  : _vm.unit
                                                                      .isSubUnit,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.unit
                                                                      .isSubUnit,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c =
                                                                    $$el.checked
                                                                      ? true
                                                                      : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      null,
                                                                    $$i =
                                                                      _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      _vm.$set(
                                                                        _vm.unit,
                                                                        "isSubUnit",
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        )
                                                                      )
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      _vm.$set(
                                                                        _vm.unit,
                                                                        "isSubUnit",
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          )
                                                                      )
                                                                  }
                                                                } else {
                                                                  _vm.$set(
                                                                    _vm.unit,
                                                                    "isSubUnit",
                                                                    $$c
                                                                  )
                                                                }
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ],
                                    ],
                                    2
                                  ),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.tabs.planning.active === true,
                                          expression:
                                            "tabs.planning.active === true",
                                        },
                                      ],
                                      staticClass: "list-container",
                                    },
                                    [
                                      _vm.unitPlanning !== null
                                        ? _c(
                                            "div",
                                            { staticClass: "item-list" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "table-responsive",
                                                },
                                                [
                                                  _c(
                                                    "table",
                                                    {
                                                      staticClass:
                                                        "table table-sm table-bordered",
                                                      attrs: {
                                                        id: "planning-table",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "thead",
                                                        {
                                                          staticClass:
                                                            "text-center",
                                                        },
                                                        [
                                                          _c("tr", [
                                                            _c(
                                                              "th",
                                                              {
                                                                attrs: {
                                                                  rowspan: "2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "startDate"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                attrs: {
                                                                  rowspan: "2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "endDate"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                attrs: {
                                                                  rowspan: "2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "duration"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                attrs: {
                                                                  rowspan: "2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "cost"
                                                                      )
                                                                    ) +
                                                                    " (K" +
                                                                    _vm._s(
                                                                      _vm.getCurrencySymbol()
                                                                    ) +
                                                                    ") "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                attrs: {
                                                                  rowspan: "2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "outageId"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                attrs: {
                                                                  rowspan: "2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "outageTitle"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                attrs: {
                                                                  rowspan: "2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "outageDescription"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                attrs: {
                                                                  colspan: "2",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "outageRiskOfExtension"
                                                                      )
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                            !_vm.unit.isSubUnit
                                                              ? _c("th", {
                                                                  attrs: {
                                                                    rowspan:
                                                                      "2",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                          ]),
                                                          _c("tr", [
                                                            _c("th", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "outageExtensionDays"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                            _c("th", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "outageExtensionTechnicalProbability"
                                                                  )
                                                                )
                                                              ),
                                                            ]),
                                                          ]),
                                                        ]
                                                      ),
                                                      _c(
                                                        "tbody",
                                                        _vm._l(
                                                          _vm.unitPlanning,
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c("tr", [
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _c(
                                                                    "date-picker",
                                                                    {
                                                                      attrs: {
                                                                        format:
                                                                          _vm.DATE_FORMAT,
                                                                        disabled:
                                                                          !item.editMode,
                                                                        type: "datetime",
                                                                        "value-type":
                                                                          "format",
                                                                        "input-class":
                                                                          [
                                                                            {
                                                                              "is-invalid":
                                                                                _vm.getValidateObject(
                                                                                  "[" +
                                                                                    index +
                                                                                    "].EndDate"
                                                                                ) ||
                                                                                _vm.isInputInvalid(
                                                                                  item.startDate,
                                                                                  item.startDateChanged
                                                                                ),
                                                                            },
                                                                            "form-control form-control-sm",
                                                                          ],
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.handleStartDateChanged(
                                                                              item
                                                                            )
                                                                          },
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          item.startDate,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              item,
                                                                              "startDate",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "item.startDate",
                                                                      },
                                                                    }
                                                                  ),
                                                                  _vm.getValidateObject(
                                                                    "[" +
                                                                      index +
                                                                      "].StartDate"
                                                                  )
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "invalid-feedback d-block",
                                                                        },
                                                                        _vm._l(
                                                                          _vm.getValidateObject(
                                                                            "[" +
                                                                              index +
                                                                              "].StartDate"
                                                                          ),
                                                                          function (
                                                                            error
                                                                          ) {
                                                                            return _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      error
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          }
                                                                        ),
                                                                        0
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _c(
                                                                    "date-picker",
                                                                    {
                                                                      attrs: {
                                                                        format:
                                                                          _vm.DATE_FORMAT,
                                                                        disabled:
                                                                          !item.editMode,
                                                                        type: "datetime",
                                                                        "value-type":
                                                                          "format",
                                                                        "input-class":
                                                                          [
                                                                            {
                                                                              "is-invalid":
                                                                                _vm.getValidateObject(
                                                                                  "[" +
                                                                                    index +
                                                                                    "].EndDate"
                                                                                ) ||
                                                                                _vm.isInputInvalid(
                                                                                  item.endDate,
                                                                                  item.endDateChanged
                                                                                ),
                                                                            },
                                                                            "form-control form-control-sm",
                                                                          ],
                                                                      },
                                                                      on: {
                                                                        change:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.handleEndDateChanged(
                                                                              item
                                                                            )
                                                                          },
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          item.endDate,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              item,
                                                                              "endDate",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "item.endDate",
                                                                      },
                                                                    }
                                                                  ),
                                                                  _vm.getValidateObject(
                                                                    "[" +
                                                                      index +
                                                                      "].EndDate"
                                                                  )
                                                                    ? _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "invalid-feedback d-block",
                                                                        },
                                                                        _vm._l(
                                                                          _vm.getValidateObject(
                                                                            "[" +
                                                                              index +
                                                                              "].EndDate"
                                                                          ),
                                                                          function (
                                                                            error
                                                                          ) {
                                                                            return _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  " " +
                                                                                    _vm._s(
                                                                                      error
                                                                                    ) +
                                                                                    " "
                                                                                ),
                                                                              ]
                                                                            )
                                                                          }
                                                                        ),
                                                                        0
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            item.duration,
                                                                          expression:
                                                                            "item.duration",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-control form-control-sm",
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "[" +
                                                                              index +
                                                                              "].duration"
                                                                          ),
                                                                      },
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      disabled:
                                                                        "true",
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        item.duration,
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            item,
                                                                            "duration",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "[" +
                                                                              index +
                                                                              "].duration"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "[" +
                                                                          index +
                                                                          "].duration"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  error
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            item.cost,
                                                                          expression:
                                                                            "item.cost",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-control form-control-sm",
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "[" +
                                                                              index +
                                                                              "].cost"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            item.cost,
                                                                            item.costChanged,
                                                                            1
                                                                          ),
                                                                      },
                                                                    ],
                                                                    attrs: {
                                                                      type: "number",
                                                                      min: "0",
                                                                      disabled:
                                                                        !item.editMode,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        item.cost,
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            item,
                                                                            "cost",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "[" +
                                                                              index +
                                                                              "].cost"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "[" +
                                                                          index +
                                                                          "].cost"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  error
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            item.outageId,
                                                                          expression:
                                                                            "item.outageId",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-control form-control-sm",
                                                                    class: [
                                                                      {
                                                                        "is-invalid":
                                                                          _vm.getValidateObject(
                                                                            "[" +
                                                                              index +
                                                                              "].OutageId"
                                                                          ) ||
                                                                          _vm.isInputInvalid(
                                                                            item.outageId,
                                                                            item.outageIdChanged
                                                                          ),
                                                                      },
                                                                    ],
                                                                    attrs: {
                                                                      type: "text",
                                                                      disabled:
                                                                        !item.editMode,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        item.outageId,
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            item,
                                                                            "outageId",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      class: {
                                                                        "invalid-feedback":
                                                                          _vm.getValidateObject(
                                                                            "[" +
                                                                              index +
                                                                              "].OutageId"
                                                                          ),
                                                                      },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.getValidateObject(
                                                                        "[" +
                                                                          index +
                                                                          "].OutageId"
                                                                      ),
                                                                      function (
                                                                        error
                                                                      ) {
                                                                        return _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              " " +
                                                                                _vm._s(
                                                                                  error
                                                                                ) +
                                                                                " "
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            item.outageTitle,
                                                                          expression:
                                                                            "item.outageTitle",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-control form-control-sm",
                                                                    attrs: {
                                                                      type: "text",
                                                                      disabled:
                                                                        !item.editMode,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        item.outageTitle,
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            item,
                                                                            "outageTitle",
                                                                            $event
                                                                              .target
                                                                              .value
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            item.outageDescription,
                                                                          expression:
                                                                            "item.outageDescription",
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-control form-control-sm",
                                                                    attrs: {
                                                                      type: "text",
                                                                      disabled:
                                                                        !item.editMode,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        item.outageDescription,
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            item,
                                                                            "outageDescription",
                                                                            $event
                                                                              .target
                                                                              .value
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            item.extensionDays,
                                                                          expression:
                                                                            "item.extensionDays",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-control form-control-sm",
                                                                    attrs: {
                                                                      type: "number",
                                                                      min: "0",
                                                                      disabled:
                                                                        !item.editMode,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        item.extensionDays,
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            item,
                                                                            "extensionDays",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              _c(
                                                                "td",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model.number",
                                                                          value:
                                                                            item.technicalProbability,
                                                                          expression:
                                                                            "item.technicalProbability",
                                                                          modifiers:
                                                                            {
                                                                              number: true,
                                                                            },
                                                                        },
                                                                      ],
                                                                    staticClass:
                                                                      "form-control form-control-sm",
                                                                    attrs: {
                                                                      type: "number",
                                                                      min: "0",
                                                                      max: "100",
                                                                      disabled:
                                                                        !item.editMode,
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        item.technicalProbability,
                                                                    },
                                                                    on: {
                                                                      input:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          if (
                                                                            $event
                                                                              .target
                                                                              .composing
                                                                          ) {
                                                                            return
                                                                          }
                                                                          _vm.$set(
                                                                            item,
                                                                            "technicalProbability",
                                                                            _vm._n(
                                                                              $event
                                                                                .target
                                                                                .value
                                                                            )
                                                                          )
                                                                        },
                                                                      blur: function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.$forceUpdate()
                                                                      },
                                                                    },
                                                                  }),
                                                                ]
                                                              ),
                                                              !_vm.unit
                                                                .isSubUnit
                                                                ? _c(
                                                                    "td",
                                                                    {
                                                                      staticClass:
                                                                        "controls text-center",
                                                                    },
                                                                    [
                                                                      item.editMode
                                                                        ? _c(
                                                                            "svg",
                                                                            {
                                                                              staticClass:
                                                                                "ok-item-button",
                                                                              attrs:
                                                                                {
                                                                                  xmlns:
                                                                                    "http://www.w3.org/2000/svg",
                                                                                  viewBox:
                                                                                    "0 0 512 512",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.closeEditPlanning(
                                                                                      item
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "path",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      d: "M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zm0 48c110.532 0 200 89.451 200 200 0 110.532-89.451 200-200 200-110.532 0-200-89.451-200-200 0-110.532 89.451-200 200-200m140.204 130.267l-22.536-22.718c-4.667-4.705-12.265-4.736-16.97-.068L215.346 303.697l-59.792-60.277c-4.667-4.705-12.265-4.736-16.97-.069l-22.719 22.536c-4.705 4.667-4.736 12.265-.068 16.971l90.781 91.516c4.667 4.705 12.265 4.736 16.97.068l172.589-171.204c4.704-4.668 4.734-12.266.067-16.971z",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      !item.editMode
                                                                        ? _c(
                                                                            "svg",
                                                                            {
                                                                              staticClass:
                                                                                "edit-item-button",
                                                                              attrs:
                                                                                {
                                                                                  xmlns:
                                                                                    "http://www.w3.org/2000/svg",
                                                                                  viewBox:
                                                                                    "0 0 576 512",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.editPlanning(
                                                                                      _vm.unitPlanning,
                                                                                      item
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "path",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      d: "M402.3 344.9l32-32c5-5 13.7-1.5 13.7 5.7V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h273.5c7.1 0 10.7 8.6 5.7 13.7l-32 32c-1.5 1.5-3.5 2.3-5.7 2.3H48v352h352V350.5c0-2.1.8-4.1 2.3-5.6zm156.6-201.8L296.3 405.7l-90.4 10c-26.2 2.9-48.5-19.2-45.6-45.6l10-90.4L432.9 17.1c22.9-22.9 59.9-22.9 82.7 0l43.2 43.2c22.9 22.9 22.9 60 .1 82.8zM460.1 174L402 115.9 216.2 301.8l-7.3 65.3 65.3-7.3L460.1 174zm64.8-79.7l-43.2-43.2c-4.1-4.1-10.8-4.1-14.8 0L436 82l58.1 58.1 30.9-30.9c4-4.2 4-10.8-.1-14.9z",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                      !item.editMode
                                                                        ? _c(
                                                                            "svg",
                                                                            {
                                                                              staticClass:
                                                                                "delete-item-button",
                                                                              attrs:
                                                                                {
                                                                                  xmlns:
                                                                                    "http://www.w3.org/2000/svg",
                                                                                  viewBox:
                                                                                    "0 0 448 512",
                                                                                },
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.confirmPlanningDelete(
                                                                                      item
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "path",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      d: "M192 188v216c0 6.627-5.373 12-12 12h-24c-6.627 0-12-5.373-12-12V188c0-6.627 5.373-12 12-12h24c6.627 0 12 5.373 12 12zm100-12h-24c-6.627 0-12 5.373-12 12v216c0 6.627 5.373 12 12 12h24c6.627 0 12-5.373 12-12V188c0-6.627-5.373-12-12-12zm132-96c13.255 0 24 10.745 24 24v12c0 6.627-5.373 12-12 12h-20v336c0 26.51-21.49 48-48 48H80c-26.51 0-48-21.49-48-48V128H12c-6.627 0-12-5.373-12-12v-12c0-13.255 10.745-24 24-24h74.411l34.018-56.696A48 48 0 0 1 173.589 0h100.823a48 48 0 0 1 41.16 23.304L349.589 80H424zm-269.611 0h139.223L276.16 50.913A6 6 0 0 0 271.015 48h-94.028a6 6 0 0 0-5.145 2.913L154.389 80zM368 128H80v330a6 6 0 0 0 6 6h276a6 6 0 0 0 6-6V128z",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          )
                                                                        : _vm._e(),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ])
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                      !_vm.unit.isSubUnit
                                                        ? _c("tfoot", [
                                                            _c("tr", [
                                                              _c(
                                                                "td",
                                                                {
                                                                  attrs: {
                                                                    colspan:
                                                                      "10",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "svg",
                                                                    {
                                                                      staticClass:
                                                                        "add-item-button",
                                                                      attrs: {
                                                                        xmlns:
                                                                          "http://www.w3.org/2000/svg",
                                                                        viewBox:
                                                                          "0 0 448 512",
                                                                      },
                                                                      on: {
                                                                        click:
                                                                          function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.unitPlanningNewLine()
                                                                          },
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "path",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              d: "M352 240v32c0 6.6-5.4 12-12 12h-88v88c0 6.6-5.4 12-12 12h-32c-6.6 0-12-5.4-12-12v-88h-88c-6.6 0-12-5.4-12-12v-32c0-6.6 5.4-12 12-12h88v-88c0-6.6 5.4-12 12-12h32c6.6 0 12 5.4 12 12v88h88c6.6 0 12 5.4 12 12zm96-160v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48h352c26.5 0 48 21.5 48 48zm-48 346V86c0-3.3-2.7-6-6-6H54c-3.3 0-6 2.7-6 6v340c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z",
                                                                            },
                                                                        }
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                            ]),
                                                          ])
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.tabs.unitOH.active === true,
                                          expression:
                                            "tabs.unitOH.active === true",
                                        },
                                      ],
                                      attrs: { id: "unitOhTab" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { id: "unit-oh-accordion" },
                                        },
                                        _vm._l(
                                          _vm.unitOperatingHours.years,
                                          function (year, yearIdx) {
                                            return _c(
                                              "pui-collapsible",
                                              {
                                                key: year.year,
                                                staticClass: "card",
                                                attrs: { open: false },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "card-header-item",
                                                    attrs: {
                                                      slot: "collapsibleHeader",
                                                      id:
                                                        "headingOHOne" +
                                                        year.year,
                                                    },
                                                    slot: "collapsibleHeader",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "row mt-1 ml-1",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-2",
                                                          },
                                                          [
                                                            _c(
                                                              "h5",
                                                              {
                                                                staticClass:
                                                                  "text-left",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      year.year
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group flex-nowrap input-group-sm col-2 pr-0",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group-prepend",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-text",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "EOH"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model.number",
                                                                  value:
                                                                    _vm
                                                                      .unitOHYearValue[
                                                                      year.year
                                                                    ].eoh,
                                                                  expression:
                                                                    "unitOHYearValue[year.year].eoh",
                                                                  modifiers: {
                                                                    number: true,
                                                                  },
                                                                },
                                                              ],
                                                              class: [
                                                                {
                                                                  "is-invalid":
                                                                    _vm.getValidateObject(
                                                                      "years[" +
                                                                        yearIdx +
                                                                        "].months[0].eoh"
                                                                    ),
                                                                },
                                                                "form-control",
                                                              ],
                                                              attrs: {
                                                                type: "number",
                                                                min: "0",
                                                                placeholder:
                                                                  "EOH",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .unitOHYearValue[
                                                                    year.year
                                                                  ].eoh,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.yearChange(
                                                                      year,
                                                                      4,
                                                                      false
                                                                    )
                                                                  },
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  },
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      _vm
                                                                        .unitOHYearValue[
                                                                        year
                                                                          .year
                                                                      ],
                                                                      "eoh",
                                                                      _vm._n(
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    )
                                                                  },
                                                                blur: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$forceUpdate()
                                                                },
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                class: {
                                                                  "invalid-feedback":
                                                                    _vm.getValidateObject(
                                                                      "years[" +
                                                                        yearIdx +
                                                                        "].months[0].eoh"
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].eoh"
                                                                ),
                                                                function (
                                                                  error
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            error
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group flex-nowrap input-group-sm col-2 pr-0",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group-prepend",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-text",
                                                                  },
                                                                  [_vm._v("OH")]
                                                                ),
                                                              ]
                                                            ),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model.number",
                                                                  value:
                                                                    _vm
                                                                      .unitOHYearValue[
                                                                      year.year
                                                                    ]
                                                                      .operatingHours,
                                                                  expression:
                                                                    "unitOHYearValue[year.year].operatingHours",
                                                                  modifiers: {
                                                                    number: true,
                                                                  },
                                                                },
                                                              ],
                                                              class: [
                                                                {
                                                                  "is-invalid":
                                                                    _vm.getValidateObject(
                                                                      "years[" +
                                                                        yearIdx +
                                                                        "].months[0].operatingHours"
                                                                    ),
                                                                },
                                                                "form-control",
                                                              ],
                                                              attrs: {
                                                                type: "number",
                                                                min: "0",
                                                                max: "8784",
                                                                placeholder:
                                                                  "OH",
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .unitOHYearValue[
                                                                    year.year
                                                                  ]
                                                                    .operatingHours,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.yearChange(
                                                                      year,
                                                                      0,
                                                                      false
                                                                    )
                                                                  },
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  },
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      _vm
                                                                        .unitOHYearValue[
                                                                        year
                                                                          .year
                                                                      ],
                                                                      "operatingHours",
                                                                      _vm._n(
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    )
                                                                  },
                                                                blur: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$forceUpdate()
                                                                },
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                class: {
                                                                  "invalid-feedback":
                                                                    _vm.getValidateObject(
                                                                      "years[" +
                                                                        yearIdx +
                                                                        "].months[0].operatingHours"
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].operatingHours"
                                                                ),
                                                                function (
                                                                  error
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            error
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group flex-nowrap input-group-sm col-2 pr-0",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group-prepend",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-text hot-starts",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "hs"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model.number",
                                                                  value:
                                                                    _vm
                                                                      .unitOHYearValue[
                                                                      year.year
                                                                    ].hotStarts,
                                                                  expression:
                                                                    "unitOHYearValue[year.year].hotStarts",
                                                                  modifiers: {
                                                                    number: true,
                                                                  },
                                                                },
                                                              ],
                                                              class: [
                                                                {
                                                                  "is-invalid":
                                                                    _vm.getValidateObject(
                                                                      "years[" +
                                                                        yearIdx +
                                                                        "].months[0].hotStarts"
                                                                    ),
                                                                },
                                                                "form-control",
                                                              ],
                                                              attrs: {
                                                                type: "number",
                                                                min: "0",
                                                                placeholder:
                                                                  _vm.$t(
                                                                    "hotStarts"
                                                                  ),
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .unitOHYearValue[
                                                                    year.year
                                                                  ].hotStarts,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.yearChange(
                                                                      year,
                                                                      1,
                                                                      false
                                                                    )
                                                                  },
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  },
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      _vm
                                                                        .unitOHYearValue[
                                                                        year
                                                                          .year
                                                                      ],
                                                                      "hotStarts",
                                                                      _vm._n(
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    )
                                                                  },
                                                                blur: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$forceUpdate()
                                                                },
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                class: {
                                                                  "invalid-feedback":
                                                                    _vm.getValidateObject(
                                                                      "years[" +
                                                                        yearIdx +
                                                                        "].months[0].hotStarts"
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].hotStarts"
                                                                ),
                                                                function (
                                                                  error
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            error
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group flex-nowrap input-group-sm col-2 pr-0",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group-prepend",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-text warm-starts",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "ws"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model.number",
                                                                  value:
                                                                    _vm
                                                                      .unitOHYearValue[
                                                                      year.year
                                                                    ]
                                                                      .warmStarts,
                                                                  expression:
                                                                    "unitOHYearValue[year.year].warmStarts",
                                                                  modifiers: {
                                                                    number: true,
                                                                  },
                                                                },
                                                              ],
                                                              class: [
                                                                {
                                                                  "is-invalid":
                                                                    _vm.getValidateObject(
                                                                      "years[" +
                                                                        yearIdx +
                                                                        "].months[0].warmStarts"
                                                                    ),
                                                                },
                                                                "form-control",
                                                              ],
                                                              attrs: {
                                                                type: "number",
                                                                min: "0",
                                                                placeholder:
                                                                  _vm.$t(
                                                                    "warmStarts"
                                                                  ),
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .unitOHYearValue[
                                                                    year.year
                                                                  ].warmStarts,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.yearChange(
                                                                      year,
                                                                      2,
                                                                      false
                                                                    )
                                                                  },
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  },
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      _vm
                                                                        .unitOHYearValue[
                                                                        year
                                                                          .year
                                                                      ],
                                                                      "warmStarts",
                                                                      _vm._n(
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    )
                                                                  },
                                                                blur: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$forceUpdate()
                                                                },
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                class: {
                                                                  "invalid-feedback":
                                                                    _vm.getValidateObject(
                                                                      "years[" +
                                                                        yearIdx +
                                                                        "].months[0].warmStarts"
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].warmStarts"
                                                                ),
                                                                function (
                                                                  error
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            error
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group flex-nowrap input-group-sm col-2 pr-0",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group-prepend",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-text cold-starts",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "cs"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model.number",
                                                                  value:
                                                                    _vm
                                                                      .unitOHYearValue[
                                                                      year.year
                                                                    ]
                                                                      .coldStarts,
                                                                  expression:
                                                                    "unitOHYearValue[year.year].coldStarts",
                                                                  modifiers: {
                                                                    number: true,
                                                                  },
                                                                },
                                                              ],
                                                              class: [
                                                                {
                                                                  "is-invalid":
                                                                    _vm.getValidateObject(
                                                                      "years[" +
                                                                        yearIdx +
                                                                        "].months[0].coldStarts"
                                                                    ),
                                                                },
                                                                "form-control",
                                                              ],
                                                              attrs: {
                                                                type: "number",
                                                                min: "0",
                                                                placeholder:
                                                                  _vm.$t(
                                                                    "coldStarts"
                                                                  ),
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .unitOHYearValue[
                                                                    year.year
                                                                  ].coldStarts,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.yearChange(
                                                                      year,
                                                                      3,
                                                                      false
                                                                    )
                                                                  },
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  },
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      _vm
                                                                        .unitOHYearValue[
                                                                        year
                                                                          .year
                                                                      ],
                                                                      "coldStarts",
                                                                      _vm._n(
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    )
                                                                  },
                                                                blur: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$forceUpdate()
                                                                },
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                class: {
                                                                  "invalid-feedback":
                                                                    _vm.getValidateObject(
                                                                      "years[" +
                                                                        yearIdx +
                                                                        "].months[0].coldStarts"
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].coldStarts"
                                                                ),
                                                                function (
                                                                  error
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            error
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        ),
                                                        _c("div", {
                                                          staticClass: "col-1",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "card-content",
                                                    attrs: {
                                                      id:
                                                        "collapseUnitOH" +
                                                        year.year,
                                                    },
                                                  },
                                                  _vm._l(
                                                    year.months,
                                                    function (month, monthIdx) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row ml-1",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-2",
                                                            },
                                                            [
                                                              _c("h6", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    month.month
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group flex-nowrap input-group-sm col-2 pr-0",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-prepend",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-text",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "EOH"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      month.eoh,
                                                                    expression:
                                                                      "month.eoh",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "years[" +
                                                                          yearIdx +
                                                                          "].months[" +
                                                                          monthIdx +
                                                                          "].eoh"
                                                                      ),
                                                                  },
                                                                  "form-control",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  min: "0",
                                                                  placeholder:
                                                                    "EOH",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    month.eoh,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.monthChange(
                                                                        year,
                                                                        false
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        month,
                                                                        "eoh",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "years[" +
                                                                          yearIdx +
                                                                          "].months[" +
                                                                          monthIdx +
                                                                          "].eoh"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].eoh"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              error
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group flex-nowrap input-group-sm col-2 pr-0",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-prepend",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-text",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "OH"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      month.operatingHours,
                                                                    expression:
                                                                      "month.operatingHours",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "years[" +
                                                                          yearIdx +
                                                                          "].months[" +
                                                                          monthIdx +
                                                                          "].operatingHours"
                                                                      ),
                                                                  },
                                                                  "form-control",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  min: "0",
                                                                  placeholder:
                                                                    "OH",
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    month.operatingHours,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.monthChange(
                                                                        year,
                                                                        false
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        month,
                                                                        "operatingHours",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "years[" +
                                                                          yearIdx +
                                                                          "].months[" +
                                                                          monthIdx +
                                                                          "].operatingHours"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].operatingHours"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              error
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group flex-nowrap input-group-sm col-2 pr-0",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-prepend",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-text hot-starts",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "hs"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      month.hotStarts,
                                                                    expression:
                                                                      "month.hotStarts",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "years[" +
                                                                          yearIdx +
                                                                          "].months[" +
                                                                          monthIdx +
                                                                          "].hotStarts"
                                                                      ),
                                                                  },
                                                                  "form-control",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  min: "0",
                                                                  placeholder:
                                                                    _vm.$t(
                                                                      "hotStarts"
                                                                    ),
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    month.hotStarts,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.monthChange(
                                                                        year,
                                                                        false
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        month,
                                                                        "hotStarts",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "years[" +
                                                                          yearIdx +
                                                                          "].months[" +
                                                                          monthIdx +
                                                                          "].hotStarts"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].hotStarts"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            error
                                                                          )
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group flex-nowrap input-group-sm col-2 pr-0",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-prepend",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-text warm-starts",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "ws"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      month.warmStarts,
                                                                    expression:
                                                                      "month.warmStarts",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "years[" +
                                                                          yearIdx +
                                                                          "].months[" +
                                                                          monthIdx +
                                                                          "].warmStarts"
                                                                      ),
                                                                  },
                                                                  "form-control",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  min: "0",
                                                                  placeholder:
                                                                    _vm.$t(
                                                                      "warmStarts"
                                                                    ),
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    month.warmStarts,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.monthChange(
                                                                        year,
                                                                        false
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        month,
                                                                        "warmStarts",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "years[" +
                                                                          yearIdx +
                                                                          "].months[" +
                                                                          monthIdx +
                                                                          "].warmStarts"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].warmStarts"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              error
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group flex-nowrap input-group-sm col-2 pr-0",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-prepend",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-text cold-starts",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "cs"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      month.coldStarts,
                                                                    expression:
                                                                      "month.coldStarts",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "years[" +
                                                                          yearIdx +
                                                                          "].months[" +
                                                                          monthIdx +
                                                                          "].coldStarts"
                                                                      ),
                                                                  },
                                                                  "form-control",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  min: "0",
                                                                  placeholder:
                                                                    _vm.$t(
                                                                      "coldStarts"
                                                                    ),
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    month.coldStarts,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.monthChange(
                                                                        year,
                                                                        false
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        month,
                                                                        "coldStarts",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "years[" +
                                                                          yearIdx +
                                                                          "].months[" +
                                                                          monthIdx +
                                                                          "].coldStarts"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].coldStarts"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              error
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          ),
                                                          _c("div", {
                                                            staticClass:
                                                              "col-1",
                                                          }),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "pi-connection-section mt-5",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "section-title" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "unitPiConnectionTitle"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "row mt-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-3 input-group flex-nowrap input-group-sm mb-3 ml-2",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "unitEnablePiConnection"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-append",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.unit
                                                                    .enablePiConnection,
                                                                expression:
                                                                  "unit.enablePiConnection",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "checkbox",
                                                            },
                                                            domProps: {
                                                              checked:
                                                                Array.isArray(
                                                                  _vm.unit
                                                                    .enablePiConnection
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.unit
                                                                        .enablePiConnection,
                                                                      null
                                                                    ) > -1
                                                                  : _vm.unit
                                                                      .enablePiConnection,
                                                            },
                                                            on: {
                                                              change: [
                                                                function (
                                                                  $event
                                                                ) {
                                                                  var $$a =
                                                                      _vm.unit
                                                                        .enablePiConnection,
                                                                    $$el =
                                                                      $event.target,
                                                                    $$c =
                                                                      $$el.checked
                                                                        ? true
                                                                        : false
                                                                  if (
                                                                    Array.isArray(
                                                                      $$a
                                                                    )
                                                                  ) {
                                                                    var $$v =
                                                                        null,
                                                                      $$i =
                                                                        _vm._i(
                                                                          $$a,
                                                                          $$v
                                                                        )
                                                                    if (
                                                                      $$el.checked
                                                                    ) {
                                                                      $$i < 0 &&
                                                                        _vm.$set(
                                                                          _vm.unit,
                                                                          "enablePiConnection",
                                                                          $$a.concat(
                                                                            [
                                                                              $$v,
                                                                            ]
                                                                          )
                                                                        )
                                                                    } else {
                                                                      $$i >
                                                                        -1 &&
                                                                        _vm.$set(
                                                                          _vm.unit,
                                                                          "enablePiConnection",
                                                                          $$a
                                                                            .slice(
                                                                              0,
                                                                              $$i
                                                                            )
                                                                            .concat(
                                                                              $$a.slice(
                                                                                $$i +
                                                                                  1
                                                                              )
                                                                            )
                                                                        )
                                                                    }
                                                                  } else {
                                                                    _vm.$set(
                                                                      _vm.unit,
                                                                      "enablePiConnection",
                                                                      $$c
                                                                    )
                                                                  }
                                                                },
                                                                _vm.switchPIConnection,
                                                              ],
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm.unit.enablePiConnection
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-4 input-group flex-nowrap input-group-sm mb-3",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group-prepend",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "input-group-text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "unitPiStartDate"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c("date-picker", {
                                                        attrs: {
                                                          type: "date",
                                                          "value-type":
                                                            "format",
                                                          format: "YYYY-MM-DD",
                                                          "input-class": [
                                                            {
                                                              "is-invalid":
                                                                _vm.getValidateObject(
                                                                  "piStartDate"
                                                                ),
                                                            },
                                                            "form-control form-control-sm",
                                                          ],
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.unit
                                                              .piStartDate,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.unit,
                                                              "piStartDate",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "unit.piStartDate",
                                                        },
                                                      }),
                                                      _vm.getValidateObject(
                                                        "piStartDate"
                                                      )
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "invalid-feedback d-block",
                                                            },
                                                            _vm._l(
                                                              _vm.getValidateObject(
                                                                "piStartDate"
                                                              ),
                                                              function (error) {
                                                                return _c(
                                                                  "span",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        error
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm.unit.enablePiConnection
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-4 input-group flex-nowrap input-group-sm mb-3",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group-prepend",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "input-group-text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "piTag"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "select",
                                                        {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.unit.piId,
                                                              expression:
                                                                "unit.piId",
                                                            },
                                                          ],
                                                          class: [
                                                            {
                                                              "is-invalid":
                                                                _vm.getValidateObject(
                                                                  "piId"
                                                                ) ||
                                                                _vm.isInputInvalid(
                                                                  _vm.unit.piId,
                                                                  true,
                                                                  2
                                                                ),
                                                            },
                                                            "form-control",
                                                            "pi-tag-select",
                                                          ],
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              var $$selectedVal =
                                                                Array.prototype.filter
                                                                  .call(
                                                                    $event
                                                                      .target
                                                                      .options,
                                                                    function (
                                                                      o
                                                                    ) {
                                                                      return o.selected
                                                                    }
                                                                  )
                                                                  .map(
                                                                    function (
                                                                      o
                                                                    ) {
                                                                      var val =
                                                                        "_value" in
                                                                        o
                                                                          ? o._value
                                                                          : o.value
                                                                      return val
                                                                    }
                                                                  )
                                                              _vm.$set(
                                                                _vm.unit,
                                                                "piId",
                                                                $event.target
                                                                  .multiple
                                                                  ? $$selectedVal
                                                                  : $$selectedVal[0]
                                                              )
                                                            },
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.unitPiTags,
                                                          function (piTag) {
                                                            return _c(
                                                              "option",
                                                              {
                                                                key: piTag,
                                                                domProps: {
                                                                  value: piTag,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      piTag
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          class: {
                                                            "invalid-feedback":
                                                              _vm.getValidateObject(
                                                                "piId"
                                                              ),
                                                          },
                                                        },
                                                        _vm._l(
                                                          _vm.getValidateObject(
                                                            "piId"
                                                          ),
                                                          function (error) {
                                                            return _c("span", [
                                                              _vm._v(
                                                                _vm._s(error)
                                                              ),
                                                            ])
                                                          }
                                                        ),
                                                        0
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.tabs.geneva.active === true,
                                          expression:
                                            "tabs.geneva.active === true",
                                        },
                                      ],
                                      attrs: { id: "genevaTab" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mt-3",
                                          attrs: { id: "geneva-accordion" },
                                        },
                                        _vm._l(
                                          _vm.genevaOperatingHours.years,
                                          function (year, yearIdx) {
                                            return _c(
                                              "pui-collapsible",
                                              {
                                                key: year.year,
                                                staticClass: "card",
                                                attrs: { open: false },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "card-header-item",
                                                    attrs: {
                                                      slot: "collapsibleHeader",
                                                      id:
                                                        "headingGOne" +
                                                        year.year,
                                                    },
                                                    slot: "collapsibleHeader",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "row mt-1 ml-1",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "col-2",
                                                          },
                                                          [
                                                            _c(
                                                              "h5",
                                                              {
                                                                staticClass:
                                                                  "text-left",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      year.year
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group flex-nowrap input-group-sm col-4",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group-prepend",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-text",
                                                                  },
                                                                  [_vm._v("OH")]
                                                                ),
                                                              ]
                                                            ),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model.number",
                                                                  value:
                                                                    _vm
                                                                      .genevaYearValue[
                                                                      year.year
                                                                    ]
                                                                      .operatingHours,
                                                                  expression:
                                                                    "genevaYearValue[year.year].operatingHours",
                                                                  modifiers: {
                                                                    number: true,
                                                                  },
                                                                },
                                                              ],
                                                              class: [
                                                                {
                                                                  "is-invalid":
                                                                    _vm.getValidateObject(
                                                                      "years[" +
                                                                        yearIdx +
                                                                        "].months[0].operatingHours"
                                                                    ),
                                                                },
                                                                "form-control",
                                                              ],
                                                              attrs: {
                                                                type: "number",
                                                                min: "0",
                                                                placeholder:
                                                                  "OH",
                                                                disabled:
                                                                  _vm.unit
                                                                    .enableForecast,
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .genevaYearValue[
                                                                    year.year
                                                                  ]
                                                                    .operatingHours,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.yearChange(
                                                                      year,
                                                                      0,
                                                                      true
                                                                    )
                                                                  },
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  },
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      _vm
                                                                        .genevaYearValue[
                                                                        year
                                                                          .year
                                                                      ],
                                                                      "operatingHours",
                                                                      _vm._n(
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    )
                                                                  },
                                                                blur: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$forceUpdate()
                                                                },
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                class: {
                                                                  "invalid-feedback":
                                                                    _vm.getValidateObject(
                                                                      "years[" +
                                                                        yearIdx +
                                                                        "].months[0].operatingHours"
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].operatingHours"
                                                                ),
                                                                function (
                                                                  error
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            error
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "input-group flex-nowrap input-group-sm col-4",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "input-group-prepend",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "input-group-text",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "starts"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model.number",
                                                                  value:
                                                                    _vm
                                                                      .genevaYearValue[
                                                                      year.year
                                                                    ].starts,
                                                                  expression:
                                                                    "genevaYearValue[year.year].starts",
                                                                  modifiers: {
                                                                    number: true,
                                                                  },
                                                                },
                                                              ],
                                                              class: [
                                                                {
                                                                  "is-invalid":
                                                                    _vm.getValidateObject(
                                                                      "years[" +
                                                                        yearIdx +
                                                                        "].months[0].starts"
                                                                    ),
                                                                },
                                                                "form-control",
                                                              ],
                                                              attrs: {
                                                                type: "number",
                                                                min: "0",
                                                                placeholder:
                                                                  _vm.$t(
                                                                    "starts"
                                                                  ),
                                                                disabled:
                                                                  _vm.unit
                                                                    .enableForecast,
                                                              },
                                                              domProps: {
                                                                value:
                                                                  _vm
                                                                    .genevaYearValue[
                                                                    year.year
                                                                  ].starts,
                                                              },
                                                              on: {
                                                                change:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.yearChange(
                                                                      year,
                                                                      1,
                                                                      true
                                                                    )
                                                                  },
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                  },
                                                                input:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      $event
                                                                        .target
                                                                        .composing
                                                                    ) {
                                                                      return
                                                                    }
                                                                    _vm.$set(
                                                                      _vm
                                                                        .genevaYearValue[
                                                                        year
                                                                          .year
                                                                      ],
                                                                      "starts",
                                                                      _vm._n(
                                                                        $event
                                                                          .target
                                                                          .value
                                                                      )
                                                                    )
                                                                  },
                                                                blur: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.$forceUpdate()
                                                                },
                                                              },
                                                            }),
                                                            _c(
                                                              "div",
                                                              {
                                                                class: {
                                                                  "invalid-feedback":
                                                                    _vm.getValidateObject(
                                                                      "years[" +
                                                                        yearIdx +
                                                                        "].months[0].starts"
                                                                    ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                    },
                                                                },
                                                              },
                                                              _vm._l(
                                                                _vm.getValidateObject(
                                                                  "years[" +
                                                                    yearIdx +
                                                                    "].months[0].starts"
                                                                ),
                                                                function (
                                                                  error
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            error
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        ),
                                                        _c("div", {
                                                          staticClass: "col-2",
                                                        }),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "card-content",
                                                    attrs: {
                                                      id:
                                                        "collapseUnitGeneva" +
                                                        year.year,
                                                    },
                                                  },
                                                  _vm._l(
                                                    year.months,
                                                    function (month, monthIdx) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "row ml-1",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-2",
                                                            },
                                                            [
                                                              _c("h6", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    month.month
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group flex-nowrap input-group-sm col-4",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-prepend",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-text",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "OH"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      month.operatingHours,
                                                                    expression:
                                                                      "month.operatingHours",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "years[" +
                                                                          yearIdx +
                                                                          "].months[" +
                                                                          monthIdx +
                                                                          "].operatingHours"
                                                                      ),
                                                                  },
                                                                  "form-control",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  min: "0",
                                                                  placeholder:
                                                                    "OH",
                                                                  disabled:
                                                                    _vm.unit
                                                                      .enableForecast,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    month.operatingHours,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.monthChange(
                                                                        year,
                                                                        true
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        month,
                                                                        "operatingHours",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "years[" +
                                                                          yearIdx +
                                                                          "].months[" +
                                                                          monthIdx +
                                                                          "].operatingHours"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].operatingHours"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              error
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "input-group flex-nowrap input-group-sm col-4",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "input-group-prepend",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "input-group-text",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "starts"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model.number",
                                                                    value:
                                                                      month.starts,
                                                                    expression:
                                                                      "month.starts",
                                                                    modifiers: {
                                                                      number: true,
                                                                    },
                                                                  },
                                                                ],
                                                                class: [
                                                                  {
                                                                    "is-invalid":
                                                                      _vm.getValidateObject(
                                                                        "years[" +
                                                                          yearIdx +
                                                                          "].months[" +
                                                                          monthIdx +
                                                                          "].starts"
                                                                      ),
                                                                  },
                                                                  "form-control",
                                                                ],
                                                                attrs: {
                                                                  type: "number",
                                                                  min: "0",
                                                                  placeholder:
                                                                    _vm.$t(
                                                                      "starts"
                                                                    ),
                                                                  disabled:
                                                                    _vm.unit
                                                                      .enableForecast,
                                                                },
                                                                domProps: {
                                                                  value:
                                                                    month.starts,
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.monthChange(
                                                                        year,
                                                                        true
                                                                      )
                                                                    },
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      if (
                                                                        $event
                                                                          .target
                                                                          .composing
                                                                      ) {
                                                                        return
                                                                      }
                                                                      _vm.$set(
                                                                        month,
                                                                        "starts",
                                                                        _vm._n(
                                                                          $event
                                                                            .target
                                                                            .value
                                                                        )
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.$forceUpdate()
                                                                  },
                                                                },
                                                              }),
                                                              _c(
                                                                "div",
                                                                {
                                                                  class: {
                                                                    "invalid-feedback":
                                                                      _vm.getValidateObject(
                                                                        "years[" +
                                                                          yearIdx +
                                                                          "].months[" +
                                                                          monthIdx +
                                                                          "].starts"
                                                                      ),
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  _vm.getValidateObject(
                                                                    "years[" +
                                                                      yearIdx +
                                                                      "].months[" +
                                                                      monthIdx +
                                                                      "].starts"
                                                                  ),
                                                                  function (
                                                                    error
                                                                  ) {
                                                                    return _c(
                                                                      "span",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              error
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                0
                                                              ),
                                                            ]
                                                          ),
                                                          _c("div", {
                                                            staticClass:
                                                              "col-2",
                                                          }),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "enable-forecast-section mt-5",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "section-title" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "enableForecastTitle"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "row mt-3" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-6 input-group flex-nowrap input-group-sm mb-3",
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-prepend",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "enableForecast"
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "input-group-append",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group-text",
                                                        },
                                                        [
                                                          _c("input", {
                                                            directives: [
                                                              {
                                                                name: "model",
                                                                rawName:
                                                                  "v-model",
                                                                value:
                                                                  _vm.unit
                                                                    .enableForecast,
                                                                expression:
                                                                  "unit.enableForecast",
                                                              },
                                                            ],
                                                            attrs: {
                                                              type: "checkbox",
                                                            },
                                                            domProps: {
                                                              checked:
                                                                Array.isArray(
                                                                  _vm.unit
                                                                    .enableForecast
                                                                )
                                                                  ? _vm._i(
                                                                      _vm.unit
                                                                        .enableForecast,
                                                                      null
                                                                    ) > -1
                                                                  : _vm.unit
                                                                      .enableForecast,
                                                            },
                                                            on: {
                                                              change: function (
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.unit
                                                                      .enableForecast,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c =
                                                                    $$el.checked
                                                                      ? true
                                                                      : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      null,
                                                                    $$i =
                                                                      _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      _vm.$set(
                                                                        _vm.unit,
                                                                        "enableForecast",
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        )
                                                                      )
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      _vm.$set(
                                                                        _vm.unit,
                                                                        "enableForecast",
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          )
                                                                      )
                                                                  }
                                                                } else {
                                                                  _vm.$set(
                                                                    _vm.unit,
                                                                    "enableForecast",
                                                                    $$c
                                                                  )
                                                                }
                                                              },
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _vm.unit.enableForecast &&
                                              _vm.expertViewDate
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-6 input-group input-group-sm mb-3 pt-1",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "forecastDate"
                                                            )
                                                          ) +
                                                          ": " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "dateFormat"
                                                            )(
                                                              new Date(
                                                                _vm.expertViewDate
                                                              ),
                                                              "YYYY-MM-DD"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm.warningMessage
                              ? _c("div", { staticClass: "my-1" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 alert alert-warning show",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " " + _vm._s(_vm.warningMessage) + " "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm.subunitCheckWarningMessage
                              ? _c("div", { staticClass: "my-1" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 alert alert-warning show",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.subunitCheckWarningMessage
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm.errorMessage
                              ? _c("div", { staticClass: "my-1" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 alert alert-danger show",
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          " " + _vm._s(_vm.errorMessage) + " "
                                        ),
                                      ]),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "alert alert-dismissible fade",
                                class: {
                                  show: _vm.showResultBox,
                                  "alert-success": !_vm.resultError,
                                  "alert-danger": _vm.resultError,
                                },
                              },
                              [_vm._v(" " + _vm._s(_vm.result) + " ")]
                            ),
                            _vm.showUnvisitedTabsMessage === true
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "alert alert-danger alert-dismissible fade",
                                    class: {
                                      show: _vm.showUnvisitedTabsMessage,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("unvisitedTabsMessage")) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "modal-footer" }, [
                          _vm.unit !== null &&
                          _vm.unit.id > 0 &&
                          _vm.tabs.item.active === true &&
                          _vm.userHasWriteAccessToPlant
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-danger btn-sm left-unit-btn",
                                  attrs: {
                                    type: "button",
                                    disabled: _vm.waitingForSave,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.confirmDeleteUnit()
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("delete")) + " ")]
                              )
                            : _vm._e(),
                          _c(
                            "span",
                            {
                              staticClass: "wait",
                              class: { "fade-in": _vm.waitingForSave === true },
                            },
                            [_vm._v(_vm._s(_vm.$t("pleaseWait")))]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary btn-sm",
                              attrs: {
                                type: "button",
                                disabled: _vm.waitingForSave,
                                "data-dismiss": "modal",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.cancel()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-sm",
                              attrs: {
                                type: "button",
                                disabled:
                                  !_vm.userHasWriteAccessToPlant ||
                                  _vm.waitingForSave,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addUnit()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("saveChanges")) + " ")]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "modal fade",
                  attrs: {
                    id: "unitPlanningChangeConfirmationModal",
                    tabindex: "-1",
                    role: "dialog",
                    "data-keyboard": "false",
                    "data-backdrop": "false",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-dialog modal-dialog-centered",
                      attrs: { role: "document" },
                    },
                    [
                      _c("div", { staticClass: "modal-content" }, [
                        _c("div", { staticClass: "modal-header p-3" }, [
                          _c("h5", { staticClass: "m-0" }, [
                            _vm._v(
                              " " + _vm._s(_vm.$t("confirmModalTitle")) + " "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "modal-body p-3" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("unitPlanningChangeConfirmationMessage")
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "modal-footer p-3" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary btn-sm",
                              attrs: {
                                type: "button",
                                "data-dismiss": "modal",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.cancelPlanningChange()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-sm",
                              attrs: {
                                type: "button",
                                "data-dismiss": "modal",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.confirmPlanningChange()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("confirm")) + " ")]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "modal fade",
                  attrs: {
                    id: "unitPlanningDeleteConfirmationModal",
                    tabindex: "-1",
                    role: "dialog",
                    "data-keyboard": "false",
                    "data-backdrop": "false",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-dialog modal-dialog-centered",
                      attrs: { role: "document" },
                    },
                    [
                      _c("div", { staticClass: "modal-content" }, [
                        _c("div", { staticClass: "modal-header p-3" }, [
                          _c("h5", { staticClass: "m-0" }, [
                            _vm._v(
                              " " + _vm._s(_vm.$t("confirmModalTitle")) + " "
                            ),
                          ]),
                        ]),
                        _c("div", { staticClass: "modal-body p-3" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("unitPlanningDeleteConfirmationMessage")
                              ) +
                              " "
                          ),
                        ]),
                        _c("div", { staticClass: "modal-footer p-3" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary btn-sm",
                              attrs: {
                                type: "button",
                                "data-dismiss": "modal",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-sm",
                              attrs: {
                                type: "button",
                                "data-dismiss": "modal",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.deletePlanning()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("confirm")) + " ")]
                          ),
                        ]),
                      ]),
                    ]
                  ),
                ]
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }